import { render, staticRenderFns } from "./LandingServicios.vue?vue&type=template&id=4a9a7a8c&scoped=true&"
import script from "./LandingServicios.vue?vue&type=script&lang=js&"
export * from "./LandingServicios.vue?vue&type=script&lang=js&"
import style0 from "./LandingServicios.vue?vue&type=style&index=0&id=4a9a7a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a7a8c",
  null
  
)

export default component.exports